export const SET_NEXT_TRACK = 'SET_NEXT_TRACK';
export const SET_PREV_TRACK = 'SET_PREV_TRACK';
